const SALES_RADAR_MODALITIES = [
	{
		value: "LIMITED_50",
		label: "Limitada USD 50.000",
		limit: 50000,
	},
	{
		value: "LIMITED",
		label: "Limitada USD 150.000",
		limit: 150000,
	},
	{
		value: "ILIMITED",
		label: "Ilimitada USD",
	},
	{
		value: "NOT_ENABLED_TO_IMPORT",
		label: "Não habilitado para importação",
	},
];

export default SALES_RADAR_MODALITIES;
